import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

const WhyYouNeedItSlider = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(4);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 664) {
        setItemsPerPage(1);
      } else if (window.innerWidth < 1024) {
        setItemsPerPage(2);
      } else {
        setItemsPerPage(4);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const getVisibleItems = () => {
    const result = [];
    for (let i = 0; i < itemsPerPage; i++) {
      const index = (currentIndex + i) % items.length;
      result.push(items[index]);
    }
    return result;
  };

  return (
    <div className="relative">
      <div
        className={`grid gap-8 ${itemsPerPage === 1 ? "grid-cols-1" : itemsPerPage === 2 ? "md:grid-cols-2" : "md:grid-cols-2 lg:grid-cols-4"}`}
      >
        {getVisibleItems().map((item, index) => {
          const Icon = item.icon;
          return (
            <Card
              key={`${index}-${currentIndex}`}
              className="text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <CardHeader>
                <div className="mx-auto w-16 h-16 bg-brand-pink/5 rounded-full flex items-center justify-center mb-4">
                  <Icon className="w-8 h-8 text-brand-purple" />
                </div>
                <CardTitle className="text-lg">{item.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 text-sm">{item.description}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {items.length > itemsPerPage && (
        <div className="flex justify-center gap-3 mt-8">
          {Array.from({ length: items.length }).map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentIndex
                  ? "bg-brand-purple w-8"
                  : "bg-gray-300 hover:bg-brand-purple/50"
              }`}
              aria-label={`Go to item ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default WhyYouNeedItSlider;
